export default __webpack_public_path__ + "static/media/slide29.6e18be37.png";